// Browser translation tools (e.g. Google Translate) replace React-owned text nodes with <font> elements.
// When React later removes or inserts relative to those nodes it throws
// "Failed to execute 'removeChild' on 'Node'", which crashes the tree into the ErrorBoundary.
// Recover only for parents within registered travel-search containers, leaving the host DOM unchanged.
// See https://github.com/facebook/react/issues/11538
declare global {
  interface Window {
    __travelSearchTranslationContainers?: WeakSet<Node>
  }
}

export const patchDomForTranslation = (container: HTMLElement) => {
  if (typeof Node !== 'function' || !Node.prototype) return

  if (window.__travelSearchTranslationContainers) {
    window.__travelSearchTranslationContainers.add(container)
    return
  }

  const containers = new WeakSet<Node>([container])
  window.__travelSearchTranslationContainers = containers

  const isInsideTravelSearch = (parent: Node) => {
    for (let node: Node | null = parent; node; node = node.parentNode) {
      if (containers.has(node)) return true
    }
    return false
  }

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (isInsideTravelSearch(this) && child.parentNode !== this) {
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (isInsideTravelSearch(this) && referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
